import { css, styled, Theme } from "@mui/material";

import { ArticlesMainLayout } from "@components/ArticlesMainLayout";
import { ArticlesSeeAlso } from "@components/ArticlesSeeAlso";

const Margins = (theme: Theme) => css`
  ${theme.breakpoints.up("mobile")} {
    margin: 1rem;
  }
  ${theme.breakpoints.up("tablet")} {
    margin: 2rem;
  }
  ${theme.breakpoints.up("desktop")} {
    margin: 2rem 4rem;
  }
  ${theme.breakpoints.up("desktopXl")} {
    margin: 3rem 110px;
  }
`;

export const StyledArticlesMainLayout = styled(ArticlesMainLayout)(
  ({ theme }) => css`
    ${Margins(theme)}
  `,
);

export const StyledArticlesSeeAlso = styled(ArticlesSeeAlso)(
  ({ theme }) => css`
    ${Margins(theme)}
  `,
);
